import { envVar, generarTokenCifrado } from '@src/configs/envirmentVar';
import axio from 'axios';

let sessionRevalidationHandler = null;

export const setSessionRevalidationHandler = (handler) => {
  sessionRevalidationHandler = handler;
};

const handleReLoginIfNeeded = (response) => {
  const { reLogin, data } = response.data ?? {};
  if (reLogin) {
    sessionRevalidationHandler?.();
  }
  return data;
};

const isFileLikeValue = (value) =>
  (typeof File !== 'undefined' && value instanceof File) ||
  (typeof Blob !== 'undefined' && value instanceof Blob);

const isArchivoField = (key, value) =>
  key.startsWith('file') || isFileLikeValue(value);
/** Acumula varios valores bajo la misma clave (multipart con campos repetidos). */
function pushGroupedValue(bucket, key, value) {
  if (bucket[key] === undefined) {
    bucket[key] = value;
    return;
  }
  if (Array.isArray(bucket[key])) {
    bucket[key].push(value);
    return;
  }
  bucket[key] = [bucket[key], value];
}

function appendGroupedToFormData(formData, key, value) {
  if (Array.isArray(value)) {
    value.forEach((item) => formData.append(key, item));
    return;
  }
  formData.append(key, value);
}
// Utilidad para separar archivos binarios de datos textuales
function separarArchivosYDatos(formData) {
  const archivos = {};
  const datosTextuales = {};
  if (formData instanceof FormData) {
    for (let [key, value] of formData.entries()) {
      if (isArchivoField(key, value)) {
        pushGroupedValue(archivos, key, value);
      } else {
        pushGroupedValue(datosTextuales, key, value);
      }
    }
  } else if (typeof formData === 'object' && formData !== null) {
    Object.entries(formData).forEach(([key, value]) => {
      if (isArchivoField(key, value)) {
        pushGroupedValue(archivos, key, value);
      } else {
        pushGroupedValue(datosTextuales, key, value);
      }
    });
  }
  return { archivos, datosTextuales };
}

const removeContentTypeHeader = (headers = {}) => {
  Object.keys(headers).forEach((key) => {
    if (key.toLowerCase() === 'content-type') {
      delete headers[key];
    }
  });
};

export const url = envVar.REACT_APP_ENTORNO_BIENIMED_BACK;

export const urlbieni = envVar.REACT_APP_ENTORNO_BIENI_BACK;

const urlNest = envVar.REACT_APP_ENTORNO_BACK_FOR_FRONT;
const normalizedNestBaseUrl = urlNest?.replace(/\/+$/, '');

export const urlTeleconsultaLivekit = envVar.REACT_APP_LIVEKIT_URL;

export const urlTeleconsulta = `${urlNest}`;

export const servicios = axio.create({
  baseURL: url,
});

export const services = axio.create({
  baseURL: urlbieni,
});

export const serviciosNest = axio.create({
  baseURL: normalizedNestBaseUrl ? `${normalizedNestBaseUrl}/api` : undefined,
});

export const servicioTeleconsulta = axio.create({
  baseURL: urlTeleconsulta,
});

export const servicioNest = serviciosNest;

const opPublicsLegacy = ['sendEmail'];

servicios.interceptors.request.use(
  async (config) => {
    let params = config.params;
    let log = config.url;
    if (config.method !== 'get') {
      // Separar archivos y datos textuales
      const { archivos, datosTextuales } = separarArchivosYDatos(config.data);
      params = { ...datosTextuales };

      const auxToken = sessionStorage.getItem('tokenSession');
      let token = auxToken ?? null;
      const encryptedData = await handleReLoginIfNeeded(
        await generarTokenCifrado({
          ...params,
          token,
          typeFunction: 'PHP',
        })
      );
      // Reconstruir FormData con archivos y data cifrada
      const formData = new FormData();
      Object.entries(archivos).forEach(([key, value]) => {
        appendGroupedToFormData(formData, key, value);
      });
      formData.append('data', encryptedData);
      config.data = formData;
      return config;
    } else {
      // GET
      const url = new URL(config.url, window.location.origin);
      params = { ...Object.fromEntries(url.searchParams.entries()), ...params };

      const auxToken = sessionStorage.getItem('tokenSession');
      let token = auxToken ?? null;
      const encryptedData = await handleReLoginIfNeeded(
        await generarTokenCifrado({
          ...params,
          token,
          typeFunction: 'PHP',
        })
      );
      config.url = config.url.split('?')[0];
      config.params = {
        data: encryptedData,
        imestamp: new Date().getTime(),
      };
      return config;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

serviciosNest.interceptors.request.use(
  async (config) => {
    let params = config?.params ?? {};
    config.headers = config.headers ?? {};

    let log = config.url;
    if (config.method !== 'get') {
      const { archivos, datosTextuales } = separarArchivosYDatos(config.data);
      params = { ...datosTextuales };
      let auxToken = sessionStorage.getItem('tokenSession') || null;
      let token = auxToken ?? null;
      const encryptedData = await handleReLoginIfNeeded(
        await generarTokenCifrado({
          ...params,
          token,
          typeFunction: 'BFF',
        })
      );
      const formData = new FormData();
      Object.entries(archivos).forEach(([key, value]) => {
        appendGroupedToFormData(formData, key, value);
      });
      formData.append('data', encryptedData);
      config.data = formData;
      removeContentTypeHeader(config.headers);
      return config;
    } else {
      const url = new URL(config.url, window.location.origin);
      const auxParmas = Object.fromEntries(url.searchParams.entries());
      if (Object.keys(auxParmas).length > 0)
        params = Object.fromEntries(url.searchParams.entries());

      let auxToken = sessionStorage.getItem('tokenSession') || null;
      let token = auxToken ?? null;
      const encryptedData = await handleReLoginIfNeeded(
        await generarTokenCifrado({
          ...params,
          token,
          typeFunction: 'BFF',
        })
      );
      config.url = config.url.split('?')[0];
      config.params = {
        data: encryptedData,
        imestamp: new Date().getTime(),
      };
      return config;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const buildUrl = (url, op, parameters = {}) => {
  const queryString = new URLSearchParams(parameters).toString();
  return `${url}?op=${op}&${queryString}`;
};

export const buildUrlNest = (recurse) => {
  if (!recurse) {
    throw new Error('El parámetro recurse es requerido');
  }

  const normalizedBase = normalizedNestBaseUrl;
  const normalizedPath = `${recurse}`.replace(/^\/+/, '');
  const pathWithPrefix = normalizedPath.startsWith('api/')
    ? normalizedPath
    : `api/${normalizedPath}`;
  const endpoint = `${normalizedBase}/${pathWithPrefix}`;

  return { baseUrl: urlNest, endpoint };
};

export const template = {
  data: [],
  recordsTotals: 0,
  recordsFiltered: 0,
  current_page: 0,
};

export const HTTP_STATUS = {
  OK: 200,
  BAD_REQUEST: 400,
  INTERNAL_SERVER: 500,
};
//MICRO-SERVICIOS ELIMINAR
export const servicioUsuario = (form) =>
  servicios.post('controller/usuarios.php', form, {
    responseType: 'json',
  });

export const fetchcombos = async (url, op, parameters = {}, callback) => {
  const apiUrl = buildUrl(url, op, parameters);
  await servicios
    .get(apiUrl, { responseType: 'json' })
    .then((response) => callback(null, response.data.data))
    .catch((error) => callback(error, null));
};
